<header *ngIf="!isLoggedIn()" class="w-full flex justify-between items-center px-6 py-3 bg-white border-b shadow-sm sticky top-0 z-40">
    <div class="flex items-center gap-2">
        <img src="../../assets/images/logo/O360.svg" alt="Organiza360" class="h-8" />
        <span class="font-semibold text-lg text-gray-800">Organiza360</span>
    </div>

    <button
        routerLink="/"
        class="text-sm font-medium text-blue-600 hover:underline"
    >
        Entrar / Criar conta
    </button>
</header>
<section *ngIf="!isLoggedIn()" class="text-center bg-blue-50 py-4 px-6 rounded-lg border border-blue-100 shadow-sm max-w-5xl mx-auto mt-6">
    <p class="text-sm md:text-base text-gray-800">
        <strong>Crie a sua conta gratuitamente</strong> e experimente a gestão de eventos por <strong>7 dias sem limitações</strong>. <br />
        Explore o catálogo e peça o seu orçamento sem compromisso.
    </p>
</section>


<div class="flex h-full w-full">
    <!-- Sidebar: Categories -->
    <aside class="w-64 bg-white border-r p-4 hidden sm:block" *ngIf="false">
        <h2 class="text-lg font-semibold mb-4">Categorias</h2>
        <ul class="space-y-2">
            <li class="cursor-pointer hover:underline">Medalhas</li>
        </ul>
    </aside>

    <!-- Main Content -->
    <main class="flex-1 p-6 relative">
        <div class="flex flex-wrap justify-between items-center bg-white rounded-lg shadow-sm px-6 py-4 mb-6 border">
            <h1 class="text-2xl font-semibold text-gray-900 flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-blue-600">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.75c-1.84-1.1-4.34-1.5-7.5-.75V18c3.16-.75 5.66-.35 7.5.75m0-12c1.84-1.1 4.34-1.5 7.5-.75V18c-3.16-.75-5.66-.35-7.5.75m0-12v12" />
                </svg>

                Catálogo de Produtos
            </h1>

            <button
                (click)="toggleQuoteSidebar()"
                class="relative flex items-center gap-2 text-sm text-gray-700 hover:text-gray-900 transition"
            >
                <svg xmlns="http://www.w3.org/2000/svg"
                     class="h-6 w-6"
                     fill="none"
                     viewBox="0 0 24 24"
                     stroke="currentColor"
                     [ngClass]="{ 'animate-cart-bounce': cartShouldBounce }"
                     (animationend)="cartShouldBounce = false"
                >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M3 3h2l.4 2m0 0h13.2a1 1 0 01.96 1.27l-1.34 5.36a1 1 0 01-.96.73H6.16L5 6H3m3.16 10a2 2 0 100 4 2 2 0 000-4zm10.68 0a2 2 0 100 4 2 2 0 000-4z"/>
                </svg>
                <span
                    class="absolute -top-2 -right-2 bg-red-500 text-white rounded-full text-xs w-5 h-5 flex items-center justify-center shadow">
        {{ quoteItems.length }}
    </span>
            </button>

        </div>


        <!-- Product Grid -->
        <div class="grid gap-4" style="grid-template-columns: repeat(auto-fit, minmax(215px, 215px));">

            <div class="bg-white p-4 rounded-lg shadow flex flex-col justify-between h-[360px]" *ngFor="let product of products; let i = index">
                <div class="relative mb-4">
                    <img [src]="product.images[0]" alt="{{ product.name }}"
                         class="h-32 w-full object-contain rounded cursor-pointer"
                         (click)="openGallery(product)"/>

                    <!-- Zoom Icon -->
                    <button
                        class="absolute top-2 right-2 bg-white p-1 rounded-full shadow hover:bg-gray-100"
                        (click)="openGallery(product)"
                        title="Ver imagens"
                        aria-label="Ver galeria de imagens"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" fill="none"
                             viewBox="0 0 24 24"
                             stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                  d="M21 21l-4.35-4.35m1.1-5.4a7 7 0 11-14 0 7 7 0 0114 0z"/>
                        </svg>
                    </button>

                    <!-- Badge: number of images -->
                    <div *ngIf="product.images?.length > 1"
                         class="absolute bottom-2 right-2 bg-white bg-opacity-90 text-gray-800 text-xs px-2 py-0.5 rounded shadow-sm font-medium">
                        {{ product.images.length }} fotos
                    </div>
                </div>

                <h3 class="font-medium">{{ product.name }}</h3>
                <p class="text-sm text-gray-600 mb-2">{{ product.description }}</p>
                <label class="text-sm text-gray-500 mb-1 block" for="qty-{{ i }}">Quantidade</label>
                <input  id="qty-{{ i }}" type="number" [(ngModel)]="product.quantity" class="w-20 mb-2 border rounded px-2 py-1" min="1"/>
                <!-- Sucesso: Check -->
                <div *ngIf="product.addedToQuote" class="flex justify-center items-center h-10">
                    <div
                        class="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center animate-pop-check"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white" fill="none"
                             viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                  d="M5 13l4 4L19 7"/>
                        </svg>
                    </div>
                </div>

                <!-- Botão original -->
                <button
                    *ngIf="!product.addedToQuote"
                    class="w-full bg-blue-600 text-white py-1 rounded transition"
                    (click)="handleAddToQuote(product)"
                >
                    Adicionar ao orçamento
                </button>

            </div>
        </div>


        <!-- Cart floating button (mobile only) -->
        <button
            (click)="toggleQuoteSidebar()"
            class="sm:hidden fixed bottom-6 right-6 bg-blue-600 text-white p-3 rounded-full shadow-lg z-50"
            aria-label="Ver orçamento"
        >
            <div class="relative">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none"
                     viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2 9h14l-2-9m-6 0v-2a2 2 0 114 0v2"/>
                </svg>
                <span
                    class="absolute -top-2 -right-2 bg-red-500 text-white rounded-full text-xs w-5 h-5 flex items-center justify-center">
                    {{ quoteItems.length }}
                </span>
            </div>
        </button>
    </main>

    <!-- Quote Sidebar -->
    <div
        class="w-96 max-w-full bg-white shadow-lg fixed top-0 right-0 h-full p-6 transform transition-transform duration-300 z-50 flex flex-col"
        [ngClass]="{ 'translate-x-0': quoteSidebarOpen, 'translate-x-full': !quoteSidebarOpen }"
    >
        <div class="flex justify-between items-center mb-6">
            <h2 class="text-xl font-semibold">Resumo do orçamento</h2>
            <button (click)="toggleQuoteSidebar()" aria-label="Fechar">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24"
                     stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M6 18L18 6M6 6l12 12"/>
                </svg>
            </button>
        </div>

        <div class="flex-1 overflow-y-auto space-y-4" *ngIf="quoteItems.length > 0; else emptyCart">
            <div *ngFor="let item of quoteItems; let i = index" class="border-b pb-4">
                <div class="flex justify-between items-center">
                    <div>
                        <div class="flex items-center gap-3">
                            <img
                                *ngIf="item.images?.[0]"
                                [src]="item.images[0]"
                                alt="{{ item.name }}"
                                class="w-12 h-12 object-cover rounded border"
                            />
                            <p class="font-medium">{{ item.name }}</p>
                        </div>

                        <div class="flex items-center gap-2 mt-2">
                            <label class="text-sm text-gray-500">Qtd:</label>
                            <input
                                type="number"
                                [(ngModel)]="item.quantity"
                                class="w-20 border px-2 py-1 rounded text-sm"
                                min="1"
                                (change)="updateTotal()"
                            />
                        </div>
                    </div>
                    <button
                        class="text-red-500 hover:text-red-700"
                        (click)="removeItem(i)"
                        title="Remover item"
                    >
                        ✕
                    </button>
                </div>
            </div>
        </div>

        <ng-template #emptyCart>
            <p class="text-gray-500 text-sm">Nenhum produto adicionado ainda.</p>
        </ng-template>

        <div class="pt-6 mt-auto border-t">
            <div class="flex justify-between text-sm text-gray-600 mb-4">
                <span>Total de itens:</span>
                <span>{{ getTotalQuantity() }}</span>
            </div>
            <button
                class="w-full bg-green-600 text-white py-2 rounded font-medium hover:bg-green-700 transition"
                [disabled]="quoteItems.length === 0"
                (click)="navigateToQuote()"
            >
                Pedir Orçamento
            </button>
        </div>
    </div>

</div>

<!-- Image Modal -->
<div
    *ngIf="selectedProduct"
    class="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[200]"
>
    <div class="relative max-w-3xl">
        <button (click)="closeGallery()" class="absolute top-4 right-4 text-white text-2xl">✕</button>

        <!-- Slideshow -->
        <div class="flex items-center justify-center">
            <button
                (click)="prevImage()" class="text-white text-4xl px-4 hover:text-gray-300">&#8249;
            </button>

            <img
                [src]="selectedProduct.images[selectedImageIndex]"
                alt=""
                class="max-h-[80vh] max-w-full rounded shadow-lg"
            />

            <button
                (click)="nextImage()" class="text-white text-4xl px-4 hover:text-gray-300">&#8250;
            </button>
        </div>
    </div>
</div>
